export const GUIDE_QUESTIONS = [
    'How would you describe youself?',
    'What are your hobbies?',
    'What projects did you do in the past?',
    'Why do you want to work remotely?'
];
